import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FormItem, useFiltersLabel, FiltersNameEnum, FilterDrawerType } from '@blocs.filter';
import { FiltersCategoryNameEnum } from '../../shared/types';
import { Profession } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const ProfessionCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.profession);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <Profession name={FiltersNameEnum.profession} label={filtersLabelOfAudience[FiltersNameEnum.profession]} />
      </FormItem>
    )
  );
};

export default ProfessionCategory;
